// Third party libraries
import { Link, useLocation } from 'react-router-dom';
import { nanoid } from 'nanoid';
// Components
import { Icon } from '../Icon';
// Styles
import styles from './PageMenu.module.css';

export const PageMenu = ({ menuItems }) => {
  const location = useLocation();

  const items = []

  for (let key in menuItems) {
    items.push(
      <li className={styles.item} key={nanoid(10)}>
        <Link
          className={((location.pathname === `/${key.toLowerCase()}`) ? false : true) ? styles.btn : styles.activeBtn}
          to={`/${key.toLowerCase()}`}
        >

          <div className={styles.iconContainer}>
            <Icon name={menuItems[key]} />
          </div>
          {menuItems[key]}
        </Link>
      </li>
    );
  };
  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        {items.map((it) => it)}
      </ul>
    </div>
  );
};